import { useTranslation } from "react-i18next";

import type { SprintMission } from "@/campaigns/modules/sprint-mission/types";
import { isExhausted } from "@/campaigns/modules/sprint-mission/types";
import { Typography } from "@/components/ui/typography";

import { FinishedCampaignCard } from "./finished-campaign-card";

/**
 * Finished Sprint Mission in the results grid.
 *
 * A run that ended because every winner is in reads differently from one that ran out of time
 * — the spec's open question 1, answered in copy rather than in a campaign status. "Finished"
 * is the ended word on every Sprint Mission surface (#3958).
 */
export const FinishedSprintMissionCard = ({
  sprintMission,
}: {
  sprintMission: SprintMission;
}) => {
  const { t } = useTranslation();

  return (
    <FinishedCampaignCard campaign={sprintMission.campaign}>
      <Typography tag="p">
        {isExhausted(sprintMission)
          ? t("sprintMission.allWinnersIn", "All winners are in")
          : t("sprintMission.finishedShort", "Finished")}
      </Typography>
    </FinishedCampaignCard>
  );
};
